import { render, staticRenderFns } from "./defineixCampanya.vue?vue&type=template&id=154fa61d"
import script from "./defineixCampanya.vue?vue&type=script&lang=js"
export * from "./defineixCampanya.vue?vue&type=script&lang=js"
import style0 from "./defineixCampanya.vue?vue&type=style&index=0&id=154fa61d&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports